import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import {
  COMMONS_ENVIRONMENT,
  ConfigLoader,
  EnvironmentConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  ServerSettingsService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const commonsProvidersFrom = [];

export const commonsProviders = [
  ...provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  { provide: SettingsService, useClass: ServerSettingsService },
  { provide: ConfigLoader, useClass: EnvironmentConfigLoader },
];
